module.exports = __webpack_public_path__ + "img/partner-youtube@2x.e4caeb93.png";